module.exports = __webpack_public_path__ + "static/media/add_image.eb68e49d.svg";